import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import './ClearTemplateToggle.scss';

const ClearTemplateTooggle = ({ checked, disabled, setChecked }) => (
    <label className={classNames('ClearTemplateTooggle', { disabled })}>
        <input type="checkbox" disabled={disabled} checked={checked} onChange={() => setChecked(!checked)} />
        <div className={classNames('checkbox', { checked })} /> Keep example content
    </label>
);

ClearTemplateTooggle.propTypes = {
    checked: PropTypes.bool,
    disabled: PropTypes.bool,
    setChecked: PropTypes.func,
};

export default ClearTemplateTooggle;
